import moment from 'moment';
import { getData } from '@/components/report/service';
import { computeWeightNotAbs, computeWeights } from '@/utils/query';
import {
  PlanDepartureNextSiteQuery,
  actualDepartureQuery,
  PlanDepartureBasise,
  PlanProvenceGetNext,
  PlanDepartureNextTaskNoQuery
} from '../Tables/PlanDepartureTable/Sql';
import { groupBys } from '@/utils/columnSearch';
import lodash from "lodash"

export default {
  namespace: 'centerWeightViewDepartTables',
  state: {
    tableItem: [],
    page: 1
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getPlanDeparture' });
    },
    /**
     * 干线预计出发货量
    */
    *getPlanDeparture(_, { call, put, select }) {
      let query = yield select(({ centerWeightView }) => {
        return {
          // actualDepartureCarsItem,planDepartureCarsItem,volumeItem,centerFilter,provinceArea
          ...centerWeightView,
          siteName: centerWeightView.centerFilter.replace('分拨中心', ''),
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });

      //#region 获取出发分拨集合
      let scanSiteArr = [query.centerFilter]
      let filter = {}
      if (!query.centerFilter) {
        filter = PlanProvenceGetNext({
          startDate: query.startDate,
          endDate: query.endDate,
          scanProvinceArea: query.provinceArea?.name
        })
        const data = yield call(getData, filter);
        scanSiteArr = Object.keys(groupBys(data, 'scanSite'))
      }
      query.centerFilter = scanSiteArr
      //#endregion

      // const dataList = []
      // for (let i = 0; i < scanSiteArr.length; i++) {
      filter = PlanDepartureBasise({
        scanSite: query.centerFilter,
        startDate: query.startDate,
        endDate: query.endDate,
      })

      const data = yield call(getData, filter);
      if (data.length > 0) {
        // 网点数据
        const nextSites = new Set()
        data.forEach(item => {
          nextSites.add(item.nextSite)      // Set排除重复项
        })
        const flowQuery = {
          scanSite: scanSiteArr,
          startDate: query.startDate,
          endDate: query.endDate,
          nextSites: [...nextSites]
        }

        const results = [];
        const filter2 = PlanDepartureNextSiteQuery(flowQuery)
        // 网点/中转/库存数据
        for (let i = 0; i < filter2.length; i++) {
          const d = yield call(getData, filter2[i]);
          if (d && (i === 5 || i === 7)) {
            d.forEach(item => {
              // 将实际装车的计划planNextSite赋值给nextSite,方便处理数据
              item.nextSite = item.planNextSite
            })
          }
          results.push(d || []);
        }

        //#region 数据拼接
        //#region 已装未发 通过tms实际出发和预计出发任务号查询 druid装车数据
        let departureTaskNos = query.actualDepartureCarsItem.map(item => item.taskNo)     // 实际发车TMS任务号
        let departureTaskNos_plan = query.planDepartureCarsItem.map(item => item.taskNo)
        departureTaskNos_plan = lodash.uniqWith(departureTaskNos_plan, lodash.isEqual);   // 计划发车TMS任务号
        // 将实际装车从计划装车中排除; 0 实际装车, 1计划装车
        const planLoadTaskNos = departureTaskNos_plan.filter(item => {
          const finds = departureTaskNos.find(item2 => item === item2)
          return !finds
        });
        const departureFilter = actualDepartureQuery({                            // 实际发车查实际表, 计划发车查计划表
          scanSite: scanSiteArr,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: departureTaskNos,
          taskNos_plan: planLoadTaskNos,
        })

        const planLoadDate = yield call(getData, departureFilter[1]);
        // console.log('planLoadDate', planLoadDate.map(m => m.taskNo))
        //#endregion

        // 合并数据
        data.forEach((item, index) => {
          item.index = index;
          /// 去除下一站所属省的 省区/经营本部后缀
          let nextProvinceArea = item.nextProvinceArea.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
          item.nextProvinceArea = nextProvinceArea
          // 拼接流向(计划表: 当前站 -下一站)
          const nextSite = item.nextSite.replace('分拨中心', '');
          item.site = `${item.scanSite.replace('分拨中心', '')}-${nextSite}`;
          // 已装未发
          let mergeCars = {}
          planLoadDate.filter(item2 => {  // 根据任务号进行匹配流向,存在多任务号相同流向需要合并
            const condit = item2.nextSite === item.nextSite && item.scanSite === item2.scanSite

            if (condit) {
              if (!mergeCars.scanSite) {
                mergeCars = { ...item2, loadNoSendTaskNo: [], calcWeight: 0 }
              }
              mergeCars.calcWeight += item2.calcWeight
              mergeCars.loadNoSendTaskNo.push(item2.taskNo)
            }
            return condit
          });
          item.mergeCalcWeight = mergeCars.calcWeight ? computeWeights(mergeCars.calcWeight) : 0;
          item.loadNoSendTaskNo = mergeCars.loadNoSendTaskNo
          // 规划运力
          let volumes = query.volumeItem.find(item2 => nextSite === item2.arrivalCenter);
          item.volumes = volumes ? volumes.volumes : 0;
          // 实际运力
          let actualVolumes = query.actualVolumeList.find(item2 => (nextSite === item2.arrivalCenter));
          item.actualVolumes0 = actualVolumes ? actualVolumes.actualVolumes[0] : 0;
          item.actualVolumes1 = actualVolumes ? actualVolumes.actualVolumes[1] : 0;
          // 计划发车时间
          item.planTime2 = actualVolumes?.departureTime || '--';
          // 赋值数据
          results.forEach((item2, index2) => {
            const obj = item2.find(itm2 => itm2.nextSite === item.nextSite && itm2.scanSite === item.scanSite);
            item[`calcWeight${index2}`] = obj ? obj.calcWeight : 0;
          })
        })

        // 计算合并后数据
        let sum = 0
        data.forEach((item) => {
          // 网点预到达
          sum = computeWeightNotAbs((item.calcWeight0) - (item.calcWeight1))
          item.originCalcWeight = sum < 0 ? 0 : sum
          // 中转预到达
          sum = computeWeightNotAbs((item.calcWeight2) - (item.calcWeight3))
          item.trainsCalcWeight = sum < 0 ? 0 : sum
          // 库存
          sum = computeWeightNotAbs((item.calcWeight4) + (item.calcWeight5))
          item.stock = sum < 0 ? 0 : sum
          // 7日库存
          // sum = computeWeightNotAbs((item.calcWeight6) + (item.calcWeight7))
          // item.stock7 = sum < 0 ? 0 : sum

          // 出发合计 在库 + 干线预到达 + 网点预到达 + 已装未发
          // 在库 stock
          // 干线预到达 trainsCalcWeight
          // 网点预到达 originCalcWeight
          // 已装未发 mergeCalcWeight
          // 预出发合计 = 在库+干线预到达+网点预到达+已装未发
          const setTotal = Number(item.stock) + Number(item.originCalcWeight) +
            Number(item.mergeCalcWeight) + Number(item.trainsCalcWeight);
          item.setTotal = Number.parseFloat(setTotal.toFixed(1));
          // item.gapVolume = !item.volumes ? '' : Number.parseFloat((Number(item.volumes) - setTotal).toFixed(1));
          const actualVolumesSum = (item.actualVolumes0 + item.actualVolumes1) || 0
          item.gapVolume = Number.parseFloat((Number(actualVolumesSum) - setTotal).toFixed(1));
        })
        //#endregion

      }

      yield put({ type: 'update', payload: { tableItem: data } });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
